import React, { Suspense, lazy } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import CircularProgress from "../components/CircularProgress";
import ErrorPage from "../components/ErrorPages/ErrorPage";
import { navigateTo } from "../util/navigationService";

// Lazy-loaded components
const Receptionist = lazy(() => import("./Receptionist"));
const Admin = lazy(() => import("./Admin"));
const MRT = lazy(() => import("./MRT"));

const App = React.memo(({ grantedRoute }) => {
  return (
    <div className="gx-main-content-wrapper">
      <Suspense fallback={<CircularProgress />}>
        {grantedRoute === "admin" && (
          <Routes>
            <Route path="admin/*" element={<Admin />} />
            <Route
              path="unauthorized"
              element={
                <ErrorPage
                  errorCode={403}
                  errorAction="goHome"
                  handleAction={() => navigateTo("/admin/dashboard")}
                />
              }
            />
            <Route path="*" element={<Navigate to="unauthorized" replace />} />
          </Routes>
        )}

        {grantedRoute === "mrt" && (
          <Routes>
            <Route path="mrt/*" element={<MRT />} />
            <Route path="*" element={<Navigate to="unauthorized" replace />} />
          </Routes>
        )}

        {grantedRoute === "receptionist" && (
          <Routes>
            <Route path="receptionist/*" element={<Receptionist />} />
            <Route
              path="unauthorized"
              element={
                <ErrorPage
                  errorCode={403}
                  errorAction="goHome"
                  handleAction={() =>
                    navigateTo("/guildlibrarian/public-macros")
                  }
                />
              }
            />
            <Route path="*" element={<Navigate to="unauthorized" replace />} />
          </Routes>
        )}

        {!["admin", "mrt", "receptionist"].includes(grantedRoute) && (
          <Routes>
            <Route path="*" element={<Navigate to="unauthorized" replace />} />
          </Routes>
        )}
      </Suspense>
    </div>
  );
});

export default App;
